import { render, staticRenderFns } from "./oaTransfer.vue?vue&type=template&id=5cdbcf20&scoped=true"
import script from "./oaTransfer.vue?vue&type=script&lang=js"
export * from "./oaTransfer.vue?vue&type=script&lang=js"
import style0 from "./oaTransfer.vue?vue&type=style&index=0&id=5cdbcf20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdbcf20",
  null
  
)

export default component.exports